import DateFormat from "components/DateFormat";

const TimeFormat = DateFormat;

export default TimeFormat;
